import { CompanyLicensingTabWebComponent } from './component/CompanyLicensingTabWebComponent';
import { WEB_COMPONENT_COMPANY_LICENSING_TAB } from '../../../webcomponents.constants';

export { CompanyLicensingTabWebComponent };

window.customElements.define(WEB_COMPONENT_COMPANY_LICENSING_TAB, CompanyLicensingTabWebComponent);
